/**
 * Professions Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";
import AppConfig from "../../../constants/AppConfig";

// States
const state = {
    doctorAdvice: {},
    doctorAdvices: [],
};

// Getters
const getters = {
    doctorAdvice: state => {
        return state.doctorAdvice
    },

    doctorAdvices: state => {
        return state.doctorAdvices
    }
};

// Actions
const actions = {
    getDoctorAdvices(context, payload) {
        function successCallback(response) {
            context.commit('getDoctorAdvicesHandler', { doctorAdvices: response.data.avis });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.DoctorAdvice.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getDoctorAdvice(context, payload) {
        function successCallback(response) {
            context.commit('getDoctorAdviceHandler', { doctorAdvice: response.data.avis });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.DoctorAdvice.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createDoctorAdvice(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            // Here we add a follow-up to the list of follow-ups
            context.commit('pushDoctorAdviceHandler', { doctorAdvice: response.data.doctorAdvice });


            // we can leave to the route of a tracking display
            // We assume that if there's a view to display a tracker or followed-up, that we call it suivi
            // router.push({ name: 'suivi', params: { suivi: response.data.suivi.slug } });
            router.push({ name: 'medical-advice' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.DoctorAdvice.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateDoctorAdvice(context, payload) {
        function successCallback(response) {
            if (payload.shouldSentNotification) {
                Vue.swal(
                    payload.successMessage,
                    '',
                    'success'
                );
            }

            // store.dispatch('findAndRemove', {name: 'suivi' });

            //We assume that if there's a view to display a tracker
            //or followed-up, that we call it suivi

            if (payload.shouldRedirect)
                router.push({ name: 'show-medical-advice', params: {medicalAdviceSlug: payload.medicalAdviceSlug} });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        const url = AppConfig.apiUrl + apiModel.DoctorAdvice.Create.url + '/' + payload.adviceResponseSlug;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    // 'Content-Type': 'multipart/form-data'
                }
            }
        )
        .then(successCallback)
        .catch(errorCallback);

        //makeApiRequest(payload.args, apiModel.Followed.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    newEditDoctorAdvice(context, payload) {
        function successCallback(response) {
            if (payload.shouldSentNotification) {
                Vue.swal(
                    payload.successMessage,
                    '',
                    'success'
                );
            }

            // store.dispatch('findAndRemove', {name: 'suivi' });

            //We assume that if there's a view to display a tracker
            //or followed-up, that we call it suivi

            if (payload.shouldRedirect)
                router.push({ name: 'show-medical-advice', params: {medicalAdviceSlug: payload.medicalAdviceSlug} });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        const url = AppConfig.apiUrl + apiModel.DoctorAdvice.EditExisting.url.replace(':avisMedecin', payload.medicalAdviceSlug);

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    // 'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);

        //makeApiRequest(payload.args, apiModel.Followed.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteDoctorAdvice(context, payload) {
        function successCallback(response) {
            context.commit('deleteDoctorAdviceHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        const url = AppConfig.apiUrl + apiModel.DoctorAdvice.Create.url + '/' + payload.slug;

        Vue.axios.delete(
            url,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    // 'Content-Type': 'multipart/form-data'
                }
            }
        )
        .then(successCallback)
        .catch(errorCallback);

        // makeApiRequest(payload.args, apiModel.Followed.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getDoctorAdviceHandler(state, { doctorAdvice }) {
        // Update followed state
        state.doctorAdvice = doctorAdvice;
    },

    getDoctorAdvicesHandler(state, { doctorAdvices }) {
        // Update followed state
        state.doctorAdvices = doctorAdvices;
    },

    pushDoctorAdviceHandler(state, { doctorAdvice }) {
        // Update followed state
        state.doctorAdvices.push(doctorAdvice);
    },

    deleteDoctorAdviceHandler(state, { index, successMessage }) {
        let i = state.doctorAdvices.findIndex(doctorAdvice => doctorAdvice.slug === index);

        if (~i) {
            state.doctorAdvices.splice(i, 1);

            // After deleting from the list of follow-ups you can go to the listing route
            // if you wish. Please note that if we are on the follow-ups listing page,
            // the list of follow-ups is already updated as of this date.

            //We assume that if there is a view to display the
            // follow-ups, that we call it follow-ups
            router.push({ name: 'medical-advice' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}
